import type { SearchStore } from '@/scopes/search/search/infrastructure/store/store';
import { useStore } from 'zustand';
import { identity } from 'ramda';

import { useDependencies } from '@/scopes/common/infrastructure/dependencies';

export const useSearchStore = () => {
  const { searchStore } = useDependencies();
  return useStore(searchStore, identity<SearchStore>);
};
